import { useMutation } from '@tanstack/react-query';

import { ProfitAndLossApi } from '../profitAndLoss.api';

export const useGetProfitAndLossCalculations = () => {
  return useMutation({
    mutationFn: ProfitAndLossApi.getCalculationsOfProfitAndLoss,
  });
};
